import { render, staticRenderFns } from "./SpotPageSummary.vue?vue&type=template&id=f15812d8"
import script from "./SpotPageSummary.vue?vue&type=script&lang=js"
export * from "./SpotPageSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports